import React, { useEffect, useState } from 'react';
import { supabase } from '../../config/supabaseClient';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { signOut } from '../../Utils/HelperFunction/HelperFunction';

interface FirstLoginModalProps {
  username: string;
  onClose: () => void;
}

const FirstLoginModal: React.FC<FirstLoginModalProps> = ({ username }) => {
  const navigate = useNavigate();

  const handleBookCall = () => {
    // Add your booking calendar link here
    window.open('YOUR_BOOKING_LINK', '_blank');
  };

  const handleTutorials = () => {
    window.open('/tutorials', '_blank');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(10px)'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        maxWidth: '550px',
        width: '90%',
        position: 'relative',
        animation: 'slideDown 0.5s ease-out'
      }}>
        {/* <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#6B7280',
            padding: '8px',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
            outline: 'none'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#F3F4F6';
            e.currentTarget.style.color = '#111827';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#6B7280';
          }}
        >
          ✕
        </button> */}

        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: '#f0fdf4',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#22c55e"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ animation: 'spin 1s linear infinite' }}
            >
              <circle cx="12" cy="12" r="10" strokeDasharray="60" strokeDashoffset="20" />
            </svg>
          </div>
          <h1 style={{
            color: '#111827',
            margin: '0 0 12px 0',
            fontSize: '24px',
            fontWeight: 'bold',
            lineHeight: '1.2',
            textAlign: 'center'
          }}>
            We're just finishing up!
          </h1>
        </div>

        <div style={{
          color: '#4b5563',
          fontSize: '16px',
          lineHeight: '1.6',
          textAlign: 'center'
        }}>
          <p style={{ marginBottom: '16px' }}>
          We're still syncing your content and setting up your dashboard. This can take up to <b>48 hours</b>, and we'll email you as soon as everything is ready!
          </p>
          <p style={{ marginBottom: '24px' }}>
          <b>While you wait, feel free to:</b> 
          </p>

          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>

            <Button
              // onClick={handleBookCall}
              type='primary'
            // className="carousel-content-add-btn"
            >
              Book Strategy Call
            </Button>
            <Button
              // onClick={handleBookCall}
              type='primary'
            // className="carousel-content-add-btn"
            >
              Contact Support
            </Button>
          </div>
          <div className='mt-4' style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>


            <Button
              onClick={handleTutorials}
              type='primary'
            >
              Check Out Tutorials
            </Button>


<Button
  onClick={()=>{
    signOut()
    navigate("/", { replace: true });
  }}
  type='primary'
>
  Sign Out
</Button>
</div>
        </div>
      </div>
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default FirstLoginModal; 